import React from 'react';
import DentalServicePage from './DentalServicePage';

const WisdomToothExtraction = () => {
    // Defined content for Wisdom Tooth Extraction
    const serviceName = 'Wisdom Tooth Extraction';
    const serviceTagline = 'Safe, comfortable wisdom tooth removal by experienced oral surgeons';

    const whatIsContent = [
        "Wisdom tooth extraction is a surgical procedure to remove one or more wisdom teeth — the four permanent adult teeth located at the back corners of your mouth on the top and bottom. These teeth are the last to emerge, usually between the ages of 17 and 25, and often don't have enough room to develop normally.",
        "When wisdom teeth don't have room to grow properly, they may become impacted, growing at an angle toward the next tooth or the back of the mouth. This can cause pain, infection, and other dental problems. At Wisdom Dental Clinic, our experienced surgeons perform comfortable wisdom tooth extractions using advanced techniques and appropriate sedation options.",
    ];

    const whenRequiredContent = {
        paragraphs: ['Not all wisdom teeth require removal, but extraction is often recommended to prevent future problems.'],
        listIntro: 'Wisdom tooth extraction may be necessary if you experience:',
        list: [
            'Pain or discomfort around the back of your mouth',
            'Infection or gum disease (pericoronitis)',
            'Tooth decay in partially erupted wisdom teeth',
            'Damage to neighboring teeth',
            'Development of cysts or tumors around wisdom teeth',
            'Crowding of other teeth',
            'Impaction (teeth trapped in the jawbone or gums)',
        ],
        closing:
            "Even if you aren't experiencing symptoms, your dentist might recommend preventive extraction of wisdom teeth if X-rays show they could cause problems in the future.",
    };

    const howDoneContent = {
        paragraphs: [
            'At Wisdom Dental Clinic, our oral surgeons are specialists in wisdom tooth extractions, ensuring a smooth and comfortable experience.',
        ],
        listIntro: 'Our wisdom tooth extraction approach includes:',
        list: [
            'Comprehensive 3D imaging for precise surgical planning',
            'Multiple sedation options including IV sedation',
            'Minimally invasive surgical techniques',
            'Advanced instruments for gentle, efficient extraction',
            'Sterile surgical environment exceeding safety standards',
            'Detailed pre-operative and post-operative care instructions',
        ],
        closing:
            'We prioritize your comfort throughout the procedure and provide extensive support for a smooth recovery process. Many patients are surprised by how quick and comfortable the procedure is with our expert team.',
    };

    const benefitsContent = [
        {
            title: 'Pain Prevention',
            description: 'Eliminates current pain and prevents future discomfort',
        },
        {
            title: 'Infection Prevention',
            description: 'Removes teeth prone to infection and bacteria buildup',
        },
        {
            title: 'Protect Other Teeth',
            description: 'Prevents damage and crowding of adjacent healthy teeth',
        },
        {
            title: 'Prevent Cysts & Tumors',
            description: 'Eliminates risk of cysts and tumors developing around impacted teeth',
        },
        {
            title: 'Improved Oral Hygiene',
            description: 'Easier to clean teeth without hard-to-reach wisdom teeth',
        },
        {
            title: 'Long-term Health',
            description: 'Contributes to overall dental health and prevents complications',
        },
    ];

    const procedureSteps = [
        {
            title: 'Comprehensive Examination',
            description:
                'Detailed examination including panoramic and 3D X-rays to evaluate wisdom tooth position and potential complications',
        },
        {
            title: 'Pre-Procedure Consultation',
            description: 'Discussion of sedation options, procedure details, and pre/post-operative instructions',
        },
        {
            title: 'Anesthesia Administration',
            description: 'Application of local anesthesia, with optional sedation based on patient preference and procedure complexity',
        },
        {
            title: 'Tooth Extraction',
            description:
                'Gentle removal of the wisdom tooth, sometimes including creation of a small incision in the gum and bone removal if necessary',
        },
        {
            title: 'Site Cleaning and Suturing',
            description: 'Thorough cleaning of the extraction site and placement of dissolving sutures if needed',
        },
        {
            title: 'Recovery and Follow-up',
            description: 'Detailed aftercare instructions, pain management, and scheduled follow-up to ensure proper healing',
        },
    ];

    const seoData = {
        title: 'Wisdom Tooth Extraction in Sector 23, Palam Vihar, Gurgaon',
        description:
            'Looking for the Best Wisdom Tooth Extraction Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable implant treatments. Call now!',
        keywords:
            'wisdom tooth extraction in Gurgaon,Best Wisdom Teeth Removal Clinic in Gurgaon,Wisdom Teeth Removal in Gurgaon,Wisdom Teeth Removal Near Me, Wisdom Teeth Removal Sector 23 gurgaon, Wisdom Teeth Removal palam vihar gurgaon',
        canonical: 'https://wisdomdentalclinics.in/wisdom-tooth-extraction',
        ogTitle: 'Wisdom Tooth Extraction in Sector 23, Palam Vihar, Gurgaon',
        ogDescription:
            'Looking for the Best Wisdom Tooth Extraction Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable implant treatments. Call now!',
        twitterTitle: 'Wisdom Tooth Extraction in Sector 23, Palam Vihar, Gurgaon',
        twitterDescription:
            'Looking for the Best Wisdom Tooth Extraction Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable implant treatments. Call now!',
        h1Text: 'Wisdom Tooth Extraction in Sector 23 Palam Vihar Gurgaon',
    };

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
            seoData={seoData}
        />
    );
};

export default WisdomToothExtraction;
